/**
 * leading debounceer for async functions
 * always returns a promise, but only resolves those called at debounced
 * intervals.
 */
export const debounceAsync = <P extends unknown[], R>(
  func: (...rest: P) => Promise<R>,
  wait: number,
): ((...rest: P) => Promise<R>) => {
  let timeout = 0;
  return function (...params: P) {
    if (!timeout) {
      // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
      timeout = setTimeout(() => {
        timeout = 0;
      }, wait);
      // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
      return Promise.resolve(func.apply(this, params));
    } else {
      clearTimeout(timeout);
      return new Promise((resolve: (result: Promise<R> | R) => void) => {
        // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
        timeout = setTimeout(() => {
          timeout = 0;
          // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
          resolve(func.apply(this, params));
        }, wait);
      });
    }
  };
};
